export default "__VITE_ASSET__26fefec8__"